import React, { Component } from 'react'
import { HashRouter, Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthProvider'
import PropTypes from 'prop-types';
import './scss/style.scss'

import ThemeProvider from './contexts/ThemeProvider'
import {


  CSpinner,

  CContainer,

} from '@coreui/react'
const loading = (
  <div className="bg-light min-vh-100 d-flex flex-row align-items-center">


    <CContainer>
      <div className="row justify-content-center mb-3">
        <CSpinner color="dark" />
      </div>
    </CContainer>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const RecuperarPassword = React.lazy(() => import('./views/pages/RecuperarPassword/RecuperarPassword.js'))
const CambiarPassword = React.lazy(() => import('./views/pages/RecuperarPassword/CambiarPassword.js'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Visorpdf = React.lazy(() => import('./views/pages/Comisiones/Visorpdf'))
class App extends Component {

  //---estoy agregando esto para probar
  constructor(props) {
    super(props);
    let logged = JSON.parse(sessionStorage.getItem('loggedin'));
    let loggedin = null;
    if (logged != null) {
      loggedin = true;
    } else {
      loggedin = false;
    }
    this.state = { loggedin: loggedin };
   // console.log(" el logged es " + this.state.loggedin)

  }


  //---aqui termina lo que estoy probando


  render() {
    const isLoggedIn = this.state.loggedin;

    return (
      <AuthProvider>
        <ThemeProvider>
          <HashRouter>
            <React.Suspense fallback={loading}>



              <Switch>

                <Route exact path="/" name="login" render={(props) => <Login {...props} />} />

                <Route exact path="/register" name="Register Page" render={(props) => <Register {...props} />} />
                <Route exact path="/recuperarpassword" name="Recuperación Password" render={(props) => <RecuperarPassword {...props} />} />
                <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
                <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
                <Route exact path="/pdf" name="Visor pdf" render={(props) => <Visorpdf {...props} />} />

                <Route path="/Principal" name="Home"

                  render={(props) => {

                    return <DefaultLayout {...props} />
                  }} />

                <Route path="/cambiarpassword" name="Cambiar Password"

                  render={(props) => {
                    return  <CambiarPassword {...props} />
                    // return isLoggedIn ? <CambiarPassword {...props} /> : <Redirect to="/" />
                  }} />

              </Switch>


              {
              
              !isLoggedIn ?
                <Redirect exact from="/" to="/" /> : <></>

              }
            </React.Suspense>
          </HashRouter>
        </ThemeProvider>
      </AuthProvider >
    )
  }
}

export default App
